import React, { useMemo } from "react";
import { InputNumber } from '@bedrock/components'
import { useControllableValue } from 'ahooks'
import {preciseFloor} from "#utils/math";

type props = {
    value?: number,
    onChange?: (value: number) => void,
    view: boolean
} & React.ComponentProps<typeof InputNumber>

const TaxRateInputNumber = (props: props) => {
    const { view, ...resProps } = props
    const [value, setValue] = useControllableValue(props, {
        defaultValue: null
    })

    const showValue = useMemo(() => {
        const newValue = typeof value !== 'number' ? '' : preciseFloor(value * 100, 1)
        return newValue;
    }, [value])

    const handleChange = (v) => {
        setValue?.(v)
    }

    return (
        <>
            {view ? (showValue ?? '--') + '%' : <InputNumber
                {...resProps}
                value={showValue}
                onChange={(val: number) => {
                    const newValue = typeof val !== 'number' ? '' : (val / 100)
                    handleChange(newValue)
                }}
                direction="vertical"
                min={0}
                toFixed={1}
                suffix={'%'}
            />}
        </>

    )
}


export default TaxRateInputNumber